'use strict';

var React = require('react');
var ClassNames = require('classnames');
var ApplicationConstants = require('../../constants/ApplicationConstants.js');
var SpinnerSizes = ApplicationConstants.SpinnerSizes;
//This component displays animated spinner leveraging font-awesome http://fontawesome.io/examples/
//PROPERTIES:
//- hide: optional, default to false which means spinner will be displayed
//- size: optional, default to one, accepts one, two, three
//- inline: optional, default to false which will make the spinner render as an inline block element
//USAGE:
//To hide the spinner set "hide" property to true
//To set the size of the spinner, the consumer of this component need to set the font-size of the spinner container and the spinner will inherit and adjust the size accordingly

var Spinner = React.createClass({
    propTypes: {
        hide: React.PropTypes.bool,
        customClass: React.PropTypes.string,
        size: React.PropTypes.oneOf([SpinnerSizes.One, SpinnerSizes.Two, SpinnerSizes.Three]),
        inline: React.PropTypes.bool
    },

    getDefaultProps: function () {
        return {
            hide: false,
            size: SpinnerSizes.One,
            inline: false
        };
    },

    render: function () {
        return (
            <div className={ClassNames(this.props.customClass, { 'ui-helper-hidden-accessible': this.props.hide, 'in-line-spinner': !this.props.hide && this.props.inline })}>
                <i className={ClassNames('spinner fa fa-refresh fa-spin fa-fw', this.props.size)}></i>
                <span className="sr-only">Loading...</span>
            </div>
		);
    }
});

module.exports = Spinner;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/Spinner.jsx